export const FILTER_TYPE = {
  INSTITUTION: 'institution_ids',
  PROCEDURE_CODE: 'code',
  PROCEDURE_NAME: 'name',
  MODALITY: 'modality',
};
